import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';

import FormattedCurrency from '../../../../../../../components/formatted-currency';
import { FormattedWeight } from '../../../../../../../components/formatted-weight';
import type { LtlShipment } from '@shipstation/client-common/types/ltl';
import { WeightUnits } from '../../../../../../../prop-types/weight-unit';
import { confirmationCardMessages } from './confirmation-card-messages';

import style from './confirmation-cards.module.less';

const CURRENCY_CODE = 'USD';

type CostCardProps = {
  shipmentDetails: LtlShipment;
};

export const CostCard = ({ shipmentDetails }: CostCardProps) => {
  return (
    <div className={style['card']}>
      <div className={style['card-header']}>
        <Text isBold textType={TextType.H4} value={confirmationCardMessages.costHeader} />
      </div>
      <div className={style['card-body']}>
        <FlexColumn gap={Gap.Space8}>
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.carrierLabel} />
            <Text textType={TextType.Paragraph} value={shipmentDetails.carrierName} />
          </FlexColumn>
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.serviceLabel} />
            <Text textType={TextType.Paragraph} value={shipmentDetails.serviceName} />
          </FlexColumn>
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.totalWeightLabel} />
            <Text
              textType={TextType.Paragraph}
              value={
                <FormattedWeight
                  weight={{
                    value: shipmentDetails.totalWeight,
                    unit: shipmentDetails.handlingUnits?.[0]?.commodities?.[0]?.weightUnit || WeightUnits.Pounds,
                  }}
                />
              }
            />
          </FlexColumn>
          <FlexColumn gap={Gap.Space4}>
            <Text className={style['detail-label']} textType={TextType.Label} value={confirmationCardMessages.totalChargesLabel} />
            <Text
              isBold
              textType={TextType.H4}
              value={<FormattedCurrency currencyCode={CURRENCY_CODE} value={shipmentDetails.totalCharges} />}
            />
          </FlexColumn>
        </FlexColumn>
      </div>
    </div>
  );
};
